export const TERMS_OF_USE_URL = 'https://www.navigatingcare.com/terms-of-use/'
export const PRIVACY_POLICY_URL = 'https://www.navigatingcare.com/privacy-policy/'
export const CONTACT_US_URL = 'https://more.navigatingcare.com/patient/contact-us.html'
